import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE02002S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

  return (
	<CommonLayout>
      <CommonMenu />
		<>
		  <div id="contents" className="container">
			<div className="sub-title bg-type02">
			  <h2>제품소개</h2>
			</div>

			<div className="location_wrap">
			  <ul className="depth1">
				<li>
				  <Link to="/">home</Link>
				</li>
				<li>
                    <a href="#none" onClick={toggleDropdown}>
                     주식매입자금대출(스탁론)<span></span>
                    </a>
				    <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                        <li>
                            <Link to="/GNBPURE02001S">온라인대출</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02002S">스탁론</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02003S">NPL</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02004S">기관연계시스템</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02000S">통합솔루션</Link>
                        </li>
                    </ul>
				</li>
			  </ul>
			</div>

			<div id="cont" className="cont">
			  <div className="inner">
				<h3>주식매입자금대출(스탁론)</h3>

				<article> 
					<div className="subtitle">스탁론시스템</div>
					<p className="txt-wrap">자사의 주식매입자금대출시스템은, 최신의 Web기술을 기반으로 고객이 은행에 방문하지 않고도 안전하게 온라인 상으로 주식담보대출을 받을 수 있는 시스템으로서 크게 ①주식담보대출 관련 Web기반 대출처리시스템과 ②중앙회, 증권사, 신용정보기관 및 Client 시스템의 연계를 위한 인터페이스 시스템, 그리고 ③주식담보 대출 관련 전용 웹사이트의 3가지로 구성되어 있습니다.</p>
				</article> 
	
				<article>
					<div className="subtitle">시스템 구성도</div>
					<div className="modal-zoom mo">
						{/* <button type="button" className="btn-sm btn-info popup-open" onclick="openModalImg('img4')">이미지 확대하기</button> */}
					</div>
					<img src="/asset/img/subC/img_product_03_1.png" alt="주식담보대출시스템의 구성도 이미지"/>
				</article>
	
				<article>
					<div className="subtitle">주요제공서비스</div>
					<div className="modal-zoom mo">
						{/* <button type="button" className="btn-sm btn-info popup-open" onclick="openModalImg('img5')">이미지 확대하기</button> */}
					</div>
					<img src="/asset/img/subC/img_product_03_2.png" alt="주식담보대출시스템의 주요제공서비스 안내 이미지"/>
				</article>
	
				<article className="pc">
					<div className="subtitle">특징</div>
					<div className="table-type table-col">
						<table>
							<caption>통합중계시스템의 특징 안내표</caption>
							<colgroup>
								<col style={{width: "33.33%"}}/>
								<col style={{width: "33.33%"}}/>
								<col style={{width: "*"}}/>
							</colgroup>
							<thead>
								<tr>
									<th scope="col">외부적 기대효과<br />(영업력 확장)</th>
									<th scope="col">내부적 기대효과<br />(수익성 증대)</th>
									<th scope="col">관리자적 기대효과<br />(효율적 관리)</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<ul className="bul-dot">
											<li>은행의 이미지 향상(웹 페이지 홍보효과)</li>
											<li>향후 타 증권사와의 연계기반 구축</li>
											<li>인터넷 전용 웹 페이지 구축으로 인한 향후 인터넷 대출 확장 기대</li>
										</ul>
									</td>
									<td>
										<ul className="bul-dot">
											<li>주식담보대출 활성화로 인한 수수료 및 이자수익 증대</li>
											<li>증권사 고객이 저축은행 고객으로 이동함에 따른 잠정적 고객 증대</li>
										</ul>
									</td>
									<td>
										<ul className="bul-dot">
											<li>주식담보로 인한 대출현황 집중관리 가능</li>
											<li>저렴한 비용으로 시스템 구축</li>
											<li>주식담보로 인하여 발생된 대출의 집계 및 통계 관리 용이</li>
											<li>표준화된시스템 구축으로 인한 관리의 효율성 강화</li>
										</ul>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</article>
	
				<article className="mo">
					<div className="subtitle">특징</div>
					<div className="table-type table-row">
						<table>
							<caption>통합중계시스템의 특징 안내표</caption>
							<colgroup>
								<col style={{width: "36%"}}/>
								<col style={{width: "*"}}/>
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">외부적 기대효과<br />(영업력 확장)</th>
									<td>
										<ul className="bul-dot">
											<li>은행의 이미지 향상(웹 페이지 홍보효과)</li>
											<li>향후 타 증권사와의 연계기반 구축</li>
											<li>인터넷 전용 웹 페이지 구축으로 인한 향후 인터넷 대출 확장 기대</li>
										</ul>
									</td>
								</tr>
								<tr>
									<th scope="row">내부적 기대효과<br />(수익성 증대)</th><td>
										<ul className="bul-dot">
											<li>주식담보대출 활성화로 인한 수수료 및 이자수익 증대</li>
											<li>증권사 고객이 저축은행 고객으로 이동함에 따른 잠정적 고객 증대</li>
										</ul>
									</td>
								</tr>
								<tr>
									<th scope="row">관리자적 기대효과<br />(효율적 관리)</th>
									<td>
										<ul className="bul-dot">
											<li>주식담보로 인한 대출현황 집중관리 가능</li>
											<li>저렴한 비용으로 시스템 구축</li>
											<li>주식담보로 인하여 발생된 대출의 집계 및 통계 관리 용이</li>
											<li>표준화된시스템 구축으로 인한 관리의 효율성 강화</li>
										</ul>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</article>
			  </div>
			</div>
		  </div>

          {/* <div className="modal-wrap modal-zoom img4">
            <div>
                <div className="modal-top">
                    <a type="button" className="btn-close" onclick="closeModal('img4')">닫기</a>
                </div>
                <div className="modal-cont">
                    <p>
                        <img src="/asset/img/subC/img_product_03_1.png" alt="주식담보대출시스템의 구성도 이미지"/>
                    </p>
                    <div className="btn-wrap">
                        <button type="button" className="btn-m btn-primary" onclick="closeModalImg('img4')">확인</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal-wrap modal-zoom img5">
            <div>
                <div className="modal-top">
                    <a type="button" className="btn-close" onclick="closeModal('img5')">닫기</a>
                </div>
                <div className="modal-cont">
                    <p>
                        <img src="/asset/img/subC/img_product_03_2.png" alt="주식담보대출시스템의 주요제공서비스 안내 이미지"/>
                    </p>
                    <div className="btn-wrap">
                        <button type="button" className="btn-m btn-primary" onclick="closeModalImg('img5')">확인</button>
                    </div>
                </div>
            </div>
        </div> */}
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE02002S;
